// src/utils/api.js
import { apiUrl } from "../config";

export async function authFetch(pathOrUrl, options = {}) {
  const url = pathOrUrl.startsWith("http") ? pathOrUrl : apiUrl(pathOrUrl);
  const token = localStorage.getItem("token"); // JWT stored on login
  // FormData bodies (file uploads) need the browser to set its own
  // multipart Content-Type with boundary — forcing application/json here
  // would send the server an unparseable body.
  const isFormData = typeof FormData !== "undefined" && options.body instanceof FormData;
  const headers = {
    ...(isFormData ? {} : { "Content-Type": "application/json" }),
    ...(options.headers || {}),
    Authorization: token ? `Bearer ${token}` : "",
  };

  const res = await fetch(url, { ...options, headers });

  if (!res.ok) {
    if (res.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      window.dispatchEvent(new Event("vaanidm:unauthorized"));
    }
    let errData = {};
    try {
      errData = await res.json();
    } catch (e) {
      // ignore JSON parse errors
    }
    throw new Error(errData.error || "Server error");
  }

  return res.json();
}

// Build a query string from an object, skipping empty/nullish values.
export function buildQuery(params = {}) {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.append(key, value);
  });
  const str = search.toString();
  return str ? `?${str}` : "";
}

// Trigger a file download from an authenticated endpoint.
export async function downloadFile(pathOrUrl, filename) {
  const url = pathOrUrl.startsWith("http") ? pathOrUrl : apiUrl(pathOrUrl);
  const token = localStorage.getItem("token");
  const res = await fetch(url, {
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });
  if (!res.ok) {
    if (res.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("user");
      window.dispatchEvent(new Event("vaanidm:unauthorized"));
    }
    throw new Error("Export failed");
  }
  const blob = await res.blob();
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.download = filename || "export";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(objectUrl);
}
